import React, { createContext, useContext, useReducer } from "react";

const RefreshContext = createContext();

const initialState = {
  refreshNeeded: false,
};

const refreshReducer = (state, action) => {
  switch (action.type) {
    case "SET_REFRESH":
      return { ...state, refreshNeeded: action.payload };
    default:
      return state;
  }
};

export const RefreshProvider = ({ children }) => {
  const [state, dispatch] = useReducer(refreshReducer, initialState);

  return (
    <RefreshContext.Provider value={{ state, dispatch }}>
      {children}
    </RefreshContext.Provider>
  );
};

export const useRefresh = () => {
  const context = useContext(RefreshContext);
  if (context === undefined) {
    throw new Error("useRefresh must be used within a RefreshProvider");
  }
  return context;
};
